module.exports = __webpack_public_path__ + "static/nodejs-89519f45883b82aa5574e08dd95c6c47.svg";